export const generadorIdAleatorio = () => {
    return Math.random() * 1000;
};